import { NavigationContainerRef, ParamListBase } from '@react-navigation/native';

const navigationReference: { ref: NavigationContainerRef<ParamListBase> | null } = { ref: null };

export default navigationReference;
